"use client"

import * as React from "react"
import { Progress as ProgressPrimitive } from "radix-ui"

import { cn } from "@/lib/utils"

function Progress({
  className,
  value,
  barColor,
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root> & { barColor?: string }) {
  const barColorStyle = barColor ? { backgroundColor: barColor } : {backgroundColor: "bg-primary/60"};
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={cn(
        "bg-muted h-1 rounded-full relative flex w-full items-center overflow-x-hidden",
        className
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className="bg-primary/60 size-full flex-1 transition-all"
        style={{ ...barColorStyle, transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    </ProgressPrimitive.Root>
  )
}

export { Progress }
